import { useCallback, useEffect, useRef, useState } from 'react';

const MOBILE_QUERY = '(max-width: 760px)';

/** Open/close state for the collapsible mobile navigation. */
export function useNavToggle() {
  const [isOpen, setIsOpen] = useState(false);
  const headerRef = useRef<HTMLElement>(null);

  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((open) => !open), []);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') close();
    };
    const onPointerDown = (event: MouseEvent) => {
      if (!headerRef.current?.contains(event.target as Node)) close();
    };
    // Never leave the panel latched open when resizing up to desktop.
    const mobile = window.matchMedia(MOBILE_QUERY);
    const onBreakpoint = (event: MediaQueryListEvent) => {
      if (!event.matches) close();
    };

    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('mousedown', onPointerDown);
    mobile.addEventListener('change', onBreakpoint);

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('mousedown', onPointerDown);
      mobile.removeEventListener('change', onBreakpoint);
    };
  }, [isOpen, close]);

  return { isOpen, toggle, close, headerRef };
}
